// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-navigation {
  width: 200px;
  background-color: var(--wellsky-indigo);
  color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
}

.nav-header {
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}

.nav-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.nav-tab {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  padding: 16px 20px;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}

.nav-tab:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-tab.active {
  background-color: var(--wellsky-blue);
  border-left-color: var(--wellsky-ocher);
}

.tab-label {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/TabNavigation/TabNavigation.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,OAAO;AACT","sourcesContent":[".tab-navigation {\n  width: 200px;\n  background-color: var(--wellsky-indigo);\n  color: white;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);\n}\n\n.nav-header {\n  padding: 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.nav-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.nav-tabs {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.nav-tab {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.9);\n  padding: 16px 20px;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: all 0.2s ease;\n  border-left: 3px solid transparent;\n}\n\n.nav-tab:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.nav-tab.active {\n  background-color: var(--wellsky-blue);\n  border-left-color: var(--wellsky-ocher);\n}\n\n.tab-label {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
